import { MdChevronRight, MdChevronLeft } from "react-icons/md";

interface ChevronButtonProps {
    direction: "left" | "right";
    onClick: () => void;
    size?: number;
    color?: string;
    disabled: boolean;
    buttonStyles: string;
    aria_label: string;
}

const ChevronButton = ({
    direction,
    onClick,
    size = 24,
    color = "#001F29",
    disabled,
    buttonStyles,
    aria_label
}: ChevronButtonProps) => {
    const Icon = direction === "left" ? MdChevronLeft : MdChevronRight;

    return (
        <div className="relative">
            <button
                onClick={onClick}
                className={`flex items-center justify-center relative z-[585] ${buttonStyles} cursor-pointer disabled:cursor-not-allowed`}
                disabled={disabled}
                aria-label={aria_label}
            >
                <Icon size={size} color={color} />
            </button>
            <div className={`w-[4rem] h-[2.5rem] top-0 absolute ${direction === "left" ? "left-0" : "right-0"}`} />
        </div>
    );
};

export default ChevronButton;
